import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReviewsService } from '@hosty-app/services';

import { ReviewsStoreEffects } from './reviews-store.effects';
import { reducer, reviewsStoreFeatureKey } from './reviews-store.reducers';

export function provideReviewsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(reviewsStoreFeatureKey, reducer),
    provideEffects([ReviewsStoreEffects]),
    ReviewsService,
  ]);
}
